/* unplugin-vue-components disabled */import { render } from "./persona.vue?vue&type=template&id=5aeb933d&scoped=true"
import script from "./persona.vue?vue&type=script&setup=true&lang=js"
export * from "./persona.vue?vue&type=script&setup=true&lang=js"

import "./persona.vue?vue&type=style&index=0&id=5aeb933d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aeb933d"],['__file',"src/components/cards/persona/persona.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aeb933d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aeb933d', __exports__)) {
    api.reload('5aeb933d', __exports__)
  }
  
  module.hot.accept("./persona.vue?vue&type=template&id=5aeb933d&scoped=true", () => {
    api.rerender('5aeb933d', render)
  })

}


export default __exports__